import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _GitlabIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.55666 2.48185C4.55545 2.47814 4.55427 2.4744 4.55313 2.47066L4.55666 2.48185ZM5.10751 4.17305L6.9992 9.97995C7.13331 10.3916 7.51708 10.6702 7.95002 10.6702H16.05C16.4833 10.6702 16.8672 10.3912 17.0011 9.97921L18.8868 4.1753L20.779 9.9992L22.0032 13.6241L12 20.894L2.0356 13.6523L5.10751 4.17305ZM19.2708 2.74187L19.2744 2.73855C19.2732 2.73967 19.272 2.74077 19.2708 2.74187ZM4.14742 1.2602C4.69363 0.762976 5.52888 0.763529 6.07444 1.26186C6.08139 1.2682 6.08824 1.27464 6.09501 1.28118C6.26559 1.44605 6.39209 1.65099 6.46305 1.87722L8.67598 8.67021H15.3235L17.539 1.8512C17.5446 1.8338 17.5507 1.81656 17.5573 1.79949C17.6371 1.59337 17.7638 1.4087 17.9274 1.2602C18.4736 0.762976 19.3089 0.763529 19.8544 1.26186C19.8614 1.2682 19.8682 1.27464 19.875 1.28118C20.0457 1.44617 20.1723 1.65128 20.2432 1.87771L22.6793 9.3756L23.9474 13.1302C23.952 13.1436 23.9562 13.157 23.9601 13.1706C24.1844 13.9406 23.8839 14.7659 23.2203 15.212L12.5879 22.9391C12.2374 23.1939 11.7627 23.1939 11.4121 22.9391L0.762123 15.1991L0.757562 15.1958C0.117075 14.7248 -0.148318 13.8958 0.0991758 13.1405L3.75896 1.8512C3.76462 1.8338 3.77075 1.81656 3.77735 1.79949C3.85706 1.59337 3.98379 1.40871 4.14742 1.2602Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const GitlabIcon = assignWithoutSideEffects(_GitlabIcon, {
  componentId: 'GitlabIcon',
});

export default GitlabIcon;
